import { FC } from 'react';
import { Tag } from '@carbon/react';
import { FloatingTooltip } from 'components/floating-tooltip';
import { formatNumber } from 'utils/number';
import { ASSIGNMENT_TYPE_LABELS, type UnitWellAssignmentRow } from './types';
import styles from './page.module.scss';

// A well with more than one current assignment (production: 2,518 wells, Oct
// 2026, almost all a best_fit left behind beside an explicit row in another
// unit): an orange count with the other units in a tooltip, and, on the best_fit
// row of such a pair, a flag that it is the likely leftover. Nothing for a
// single-assignment well.
export const AssignmentsCell: FC<{ row: UnitWellAssignmentRow }> = ({
  row,
}) => {
  if (row.wellAssignmentCount <= 1) return null;

  const others = (
    <ul className={styles.otherUnits}>
      {row.otherUnits.map((other) => (
        <li key={other.name}>
          {other.name} ({ASSIGNMENT_TYPE_LABELS[other.assignmentType]})
        </li>
      ))}
    </ul>
  );

  return (
    <span className={styles.assignmentTags}>
      <FloatingTooltip content={others}>
        <Tag size="sm" className={styles.multipleAssignmentsTag}>
          {formatNumber({
            value: row.wellAssignmentCount,
            minPrecision: 0,
            includeCommas: true,
          })}{' '}
          assignments
        </Tag>
      </FloatingTooltip>
      {row.bestFitSuperseded && (
        <Tag type="magenta" size="sm">
          best-fit superseded?
        </Tag>
      )}
    </span>
  );
};
